import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { CustomerServiceOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import { API_FETCH_BASE } from '../services/api';

export interface JoinTeamModalProps {
  open: boolean;
  onClose: () => void;
}

const JoinTeamModal: React.FC<JoinTeamModalProps> = ({ open, onClose }) => {
  const { token, login } = useAuth();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (!token) {
        message.warning('请先登录');
        return;
      }
      setLoading(true);
      const res = await fetch(`${API_FETCH_BASE}/api/auth/join-team`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ teamCode: values.teamCode.trim() }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data.error || '加入失败');
      }
      const u = data.user as Record<string, unknown>;
      login(
        data.token as string,
        String(u.role),
        String(u.username),
        (u.name as string) || String(u.username),
        (u.avatar as string) || undefined,
        Boolean(u.isFirstLogin),
        Boolean(u.passwordChanged),
        u._id != null ? String(u._id) : undefined,
        u.teamId != null ? String(u.teamId) : undefined,
        data.teamCode as string,
        data.teamName as string
      );
      message.success(`已加入团队「${data.teamName}」`);
      form.resetFields();
      onClose();
    } catch (e: unknown) {
      const err = e as { errorFields?: unknown };
      if (!err.errorFields) {
        message.error(e instanceof Error ? e.message : '加入失败');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="加入团队"
      open={open}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      footer={null}
      destroyOnHidden
      width={480}
    >
      <div className="lims-modal-callout" role="note">
        <InfoCircleOutlined aria-hidden />
        <span>
          向实验室管理员索取<strong>团队编码</strong>（与登录时填写的团队码相同），加入后您将作为该团队的普通成员。
        </span>
      </div>
      <Form form={form} layout="vertical" onFinish={handleOk}>
        <Form.Item
          name="teamCode"
          label="团队编码"
          rules={[{ required: true, message: '请输入团队编码' }]}
        >
          <Input placeholder="例如 LAB-XXXXXX" allowClear autoComplete="off" size="large" />
        </Form.Item>
        <Form.Item className="mb-0">
          <div className="lims-modal-body-footer">
            <Button type="link" icon={<CustomerServiceOutlined />} onClick={() => message.info('如有疑问请联系实验室管理员或平台客服。')}>
              联系客服
            </Button>
            <Button type="primary" htmlType="submit" loading={loading} size="large">
              确认加入
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default JoinTeamModal;
